import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { FullTable, FullTableAccordionMain } from "components";
import {
  CHARITY_FUNDRAISER_REPORTS,
  charityReportsAccordionDetails,
  charityFundraiserReportsBody,
  charityFundraiserReportsHead,
  fundraiserMobileCard,
} from "./constants";
import { ProfileInfo, useWindowDimensions } from "utils";

export const CharityFundraiserReports = ({ status }) => {
  const { charityReports } = useSelector((state) => ({
    charityReports: state.charity.charityReports,
  }));
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const { ifAdmin } = ProfileInfo();

  const goToEventPage = (item) => {
    if (ifAdmin) {
      navigate(`/events/${item?.id}`);
    }
  };

  return (
    <div>
      {width > 767 && width < 1279 ? (
        <FullTableAccordionMain
          classNameWrapper={`charities-events-table-wrapper ${
            ifAdmin ? "charities-events-table-wrapper-admin" : ""
          }`}
          head={charityFundraiserReportsHead(width, status)}
          body={charityFundraiserReportsBody(width, status)}
          mobileCard={fundraiserMobileCard(status)}
          loadingType={CHARITY_FUNDRAISER_REPORTS}
          list={charityReports?.fundraisers}
          listCount={charityReports?.count}
          accordionDetails={charityReportsAccordionDetails(status)}
          handleClick={goToEventPage}
        />
      ) : (
        <FullTable
          classNameWrapper={`charities-events-table-wrapper ${
            ifAdmin ? "charities-events-table-wrapper-admin" : ""
          }`}
          head={charityFundraiserReportsHead(width, status)}
          body={charityFundraiserReportsBody(width, status)}
          mobileCard={fundraiserMobileCard(status)}
          loadingType={CHARITY_FUNDRAISER_REPORTS}
          list={charityReports?.fundraisers}
          listCount={charityReports?.count}
          handleClick={goToEventPage}
        />
      )}
    </div>
  );
};
